module.exports = __webpack_public_path__ + "img/FNSKU-Combo_Shopping.e20f0331.png";